// German for the Admin page: the rail, the posture claims, the consequence cards, the trail,
// the switches (incl. the accent control and its record note), the modals. Registered on load.
import { registerDe } from '../i18n/index.js';

registerDe({
  // ── the accent control ──
  'Pick the accent colour': 'Akzentfarbe wählen',
  'Accent colour as hex': 'Akzentfarbe als Hex',
  "Back to ATTEST's own accent": 'Zurück zum eigenen Akzent von ATTEST',
  "ATTEST's own": 'ATTEST-eigen',
  "ATTEST's own iron-gall blue": 'Das eigene Eisengallusblau von ATTEST',
  'is in force — 6.78:1 on the field, 7.58:1 on the sheet.': 'ist in Kraft — 6.78:1 auf dem Feld, 7.58:1 auf dem Blatt.',
  'Not a colour yet — six hex digits after the #.': 'Noch keine Farbe — sechs Hex-Ziffern nach dem #.',
  'day · a link on the field': 'Tag · ein Link auf dem Feld',
  'day · a link on the sheet': 'Tag · ein Link auf dem Blatt',
  'day · text on a filled control': 'Tag · Text auf einem gefüllten Bedienelement',
  'night · a link on the field': 'Nacht · ein Link auf dem Feld',
  'night · a link on the sheet': 'Nacht · ein Link auf dem Blatt',
  'night · text on a filled control': 'Nacht · Text auf einem gefüllten Bedienelement',
  'night': 'Nacht',
  'day': 'Tag',
  'a link': 'ein Link',
  'surface': 'Fläche',
  'ratio': 'Kontrast',
  'AA {aa}:1': 'AA {aa}:1',
  'passes': 'besteht',
  'FAILS': 'FÄLLT DURCH',
  'Passes AA on every surface — Save applies it at once, for everyone, on this and every next load.':
    'Besteht AA auf jeder Fläche — Speichern wendet sie sofort an, für alle, bei diesem und jedem weiteren Laden.',
  'Save will be refused: {problems}.': 'Speichern wird abgelehnt: {problems}.',
  'The nearest shade of this hue that passes is': 'Der nächste Ton dieser Farbe, der besteht, ist',
  'use it': 'übernehmen',

  // ── loaders / rail ──
  'The vocabulary did not load': 'Das Vokabular wurde nicht geladen',
  'The trail did not load': 'Der Prüfpfad wurde nicht geladen',
  'the posture did not load': 'die Lage wurde nicht geladen',
  'unknown': 'unbekannt',
  'auth_settings did not answer': 'auth_settings hat nicht geantwortet',
  '{n} email admitted': '{n} E-Mail zugelassen',
  '{n} emails admitted': '{n} E-Mails zugelassen',
  'anyone may register': 'jeder kann sich registrieren',
  'operator': 'Operator',
  'operators': 'Operatoren',
  '{admins} admin · {plain} plain': '{admins} Admin · {plain} ohne',
  'none created yet': 'noch keines angelegt',
  'live': 'aktiv',
  'the token tally did not run': 'die Schlüsselzählung ist nicht gelaufen',
  '{total} issued · {revoked} revoked': '{total} ausgestellt · {revoked} widerrufen',
  'none issued': 'keiner ausgestellt',
  '{wired} of {total}': '{wired} von {total}',
  'wired': 'verdrahtet',
  '{n} read by nothing': '{n} von nichts gelesen',
  'every key has a reader': 'jeder Schlüssel hat einen Leser',
  'events': 'Ereignisse',
  '{n} on {date}': '{n} am {date}',
  'nothing in 30 days': 'nichts in 30 Tagen',
  'REALM': 'BEREICH',
  'ACCOUNTS': 'KONTEN',
  'AGENT KEYS': 'AGENT-SCHLÜSSEL',
  'SWITCHES': 'SCHALTER',
  'TRAIL': 'PRÜFPFAD',
  'Posture': 'Lage',
  'Switches': 'Schalter',
  'The trail': 'Der Prüfpfad',

  // ── posture claims ──
  'The registration mode could not be read — this claim did NOT pass, it did not run.':
    'Der Registrierungsmodus konnte nicht gelesen werden — diese Aussage ist NICHT bestanden, sie wurde nicht geprüft.',
  'Registration is closed. Only an admitted email can create an operator account.':
    'Die Registrierung ist geschlossen. Nur eine zugelassene E-Mail kann ein Operator-Konto anlegen.',
  'Registration is OPEN — anyone who can reach the host can create an operator account.':
    'Die Registrierung ist OFFEN — jeder, der den Host erreicht, kann ein Operator-Konto anlegen.',
  'reasserted on every boot by': 'bei jedem Start neu gesetzt durch',
  'not reasserted on boot': 'beim Start nicht neu gesetzt',
  'Close it': 'Schliessen',
  'No email is admitted — with the door shut, nothing can create an account.':
    'Keine E-Mail ist zugelassen — bei geschlossener Tür kann nichts ein Konto anlegen.',
  'One email is admitted: {email}': 'Eine E-Mail ist zugelassen: {email}',
  '{n} emails are admitted.': '{n} E-Mails sind zugelassen.',
  'since': 'seit',
  'empty': 'leer',
  'newest: {email}': 'neueste: {email}',
  'Withdraw the newest': 'Die neueste zurückziehen',
  'No account exists yet — the first admitted email creates one at first login.':
    'Noch kein Konto vorhanden — die erste zugelassene E-Mail legt beim ersten Login eines an.',
  '{n} account exists whose address is NOT on the allowlist — admitted, used, then withdrawn.':
    '{n} Konto existiert, dessen Adresse NICHT auf der Zulassungsliste steht — zugelassen, benutzt, dann zurückgezogen.',
  '{n} accounts exist whose address is NOT on the allowlist — admitted, used, then withdrawn.':
    '{n} Konten existieren, deren Adresse NICHT auf der Zulassungsliste steht — zugelassen, benutzt, dann zurückgezogen.',
  'One account exists, and it is that email: {name}': 'Ein Konto existiert, und es ist diese E-Mail: {name}',
  '{n} accounts exist. {admins} of them can write settings and read this trail.':
    '{n} Konten existieren. {admins} davon können Einstellungen schreiben und diesen Prüfpfad lesen.',
  'admin': 'Admin',
  'password set': 'Passwort gesetzt',
  'no password — SSO only': 'kein Passwort — nur SSO',
  'Change my password': 'Mein Passwort ändern',
  'The agent-key tally did not run — whether anything outside this process can reach the tool surface is UNKNOWN.':
    'Die Zählung der Agent-Schlüssel ist nicht gelaufen — ob etwas ausserhalb dieses Prozesses die Tool-Oberfläche erreichen kann, ist UNBEKANNT.',
  'No agent key is live. Nothing outside this process can reach the engagement tool surface.':
    'Kein Agent-Schlüssel ist aktiv. Nichts ausserhalb dieses Prozesses kann die Tool-Oberfläche des Auftrags erreichen.',
  '{n} agent key live and can call the tool surface.': '{n} Agent-Schlüssel ist aktiv und kann die Tool-Oberfläche aufrufen.',
  '{n} agent keys live and can call the tool surface.': '{n} Agent-Schlüssel sind aktiv und können die Tool-Oberfläche aufrufen.',
  'issued': 'ausgestellt',
  'last expiry': 'letzter Ablauf',
  'Revoke all': 'Alle widerrufen',
  'The client-account tally did not run.': 'Die Zählung der Kundenkonten ist nicht gelaufen.',
  'No client account exists. The client realm shares nothing with this one — separate cookie, separate table, separate trail.':
    'Kein Kundenkonto existiert. Der Kunden-Bereich teilt nichts mit diesem — eigenes Cookie, eigene Tabelle, eigener Prüfpfad.',
  '{accounts} across {clients}.': '{accounts} bei {clients}.',
  '{n} client account': '{n} Kundenkonto',
  '{n} client accounts': '{n} Kundenkonten',
  '{n} client': '{n} Kunde',
  '{n} clients': '{n} Kunden',
  'administered on the Client Portal tab': 'verwaltet auf dem Tab Kundenportal',

  // ── filter chips ──
  'verb': 'Verb',
  'noun': 'Nomen',
  'class': 'Klasse',
  'engagement': 'Auftrag',
  'text': 'Text',
  'carries a written reason': 'trägt eine geschriebene Begründung',
  'destroyed a row': 'hat eine Zeile zerstört',
  'produced a hash': 'hat einen Hash erzeugt',

  // ── acts / toasts ──
  'That is not an email address': 'Das ist keine E-Mail-Adresse',
  '{email} is admitted — and the act is in the trail below': '{email} ist zugelassen — und der Vorgang steht unten im Prüfpfad',
  'The email could not be admitted': 'Die E-Mail konnte nicht zugelassen werden',
  '{email} withdrawn': '{email} zurückgezogen',
  'The address could not be withdrawn': 'Die Adresse konnte nicht zurückgezogen werden',
  'Registration is closed — only an admitted email can create an account':
    'Die Registrierung ist geschlossen — nur eine zugelassene E-Mail kann ein Konto anlegen',
  'The registration mode could not be changed': 'Der Registrierungsmodus konnte nicht geändert werden',
  '{n} agent key revoked': '{n} Agent-Schlüssel widerrufen',
  '{n} agent keys revoked': '{n} Agent-Schlüssel widerrufen',
  'The keys could not be revoked': 'Die Schlüssel konnten nicht widerrufen werden',
  'The new password must be at least 8 characters': 'Das neue Passwort muss mindestens 8 Zeichen haben',
  'The two new passwords do not match': 'Die beiden neuen Passwörter stimmen nicht überein',
  'Your password is changed': 'Ihr Passwort ist geändert',
  'The password could not be changed': 'Das Passwort konnte nicht geändert werden',
  '{n} switch saved': '{n} Schalter gespeichert',
  '{n} switches saved': '{n} Schalter gespeichert',
  'The switches could not be saved': 'Die Schalter konnten nicht gespeichert werden',
  'Citation copied': 'Zitat kopiert',

  // ── masthead ──
  'Admin': 'Admin',
  'sealed': 'versiegelt',
  'open': 'offen',
  "the system's own record — the one page whose subject is Signet":
    'die eigene Aufzeichnung des Systems — die eine Seite, deren Gegenstand Signet ist',
  'read-only — you are not an admin': 'nur lesend — Sie sind kein Admin',
  'The trail is downloading with the filters you have on': 'Der Prüfpfad wird mit den aktiven Filtern heruntergeladen',
  'Export the trail': 'Prüfpfad exportieren',

  // ── zone 1 · posture ──
  'reading': 'wird gelesen',
  '{n} claims · all hold': '{n} Aussagen · alle halten',
  '{bad} of {total} do not hold': '{bad} von {total} halten nicht',
  'Admit an email': 'E-Mail zulassen',
  'The posture did not load': 'Die Lage wurde nicht geladen',
  "Reading the system's own state…": 'Der Zustand des Systems wird gelesen…',
  'The {source} claim': 'Die Aussage {source}',

  // ── zone 2 · consequence ──
  'Consequence': 'Konsequenz',
  '{decisions} of {total} entries are a decision · the rest are keystrokes':
    '{decisions} von {total} Einträgen sind eine Entscheidung · der Rest sind Tastendrücke',
  'the tallies did not run': 'die Zählungen sind nicht gelaufen',
  'The client realm has no consequence classes': 'Der Kunden-Bereich hat keine Konsequenzklassen',
  'records reading, not deciding: a client can view, comment and run a test case, and none of those destroys a row or produces a hash. Switch the trail back to the operator realm to see the three memberships.':
    'protokolliert Lesen, nicht Entscheiden: ein Kunde kann ansehen, kommentieren und einen Testfall ausführen, und nichts davon zerstört eine Zeile oder erzeugt einen Hash. Schalten Sie den Prüfpfad zurück auf den Operator-Bereich, um die drei Zugehörigkeiten zu sehen.',
  'The consequence tallies did not load': 'Die Konsequenzzählungen wurden nicht geladen',
  'The vocabulary payload carried no tallies.': 'Die Vokabular-Antwort enthielt keine Zählungen.',
  'of {n}': 'von {n}',
  'Carry a reason you typed': 'Tragen eine von Ihnen getippte Begründung',
  'Every place you went round a guarantee and had to say why.':
    'Jede Stelle, an der Sie eine Garantie umgangen haben und sagen mussten, warum.',
  'more rows carry a note, but it is one of': 'weitere Zeilen tragen eine Notiz, aber sie ist eine von',
  'constants the server writes — those are the system speaking, and they are not here.':
    'Konstanten, die der Server schreibt — das ist das System, das spricht, und die stehen nicht hier.',
  'Show them in the trail →': 'Im Prüfpfad zeigen →',
  'Destroyed a row': 'Haben eine Zeile zerstört',
  'Including': 'Darunter',
  'clients and': 'Kunden und',
  'engagements deleted with their cascades. The': 'Aufträge, mit ihren Kaskaden gelöscht. Das Feld',
  'blob in the entry is the only surviving copy of each —': 'im Eintrag ist die einzige erhaltene Kopie von jedem —',
  'characters of record that exists nowhere else in the database.':
    'Zeichen Aufzeichnung, die sonst nirgends in der Datenbank existieren.',
  'Produced a hash a signature stands on': 'Haben einen Hash erzeugt, auf dem eine Unterschrift steht',
  'Signatures, baselines and issued versions.': 'Unterschriften, Baselines und ausgegebene Versionen.',
  'The baseline is sacred': 'Die Baseline ist unantastbar',
  '— these are the entries an argument about scope is settled on, and the content hash in each is rendered whole, never truncated.':
    '— das sind die Einträge, an denen ein Streit über den Umfang entschieden wird, und der Inhalts-Hash in jedem wird ganz wiedergegeben, nie gekürzt.',
  'Membership is a query, not an opinion: a row is here when it carries a written reason, when it destroyed a row whose only surviving copy is the entry itself, or when it produced a hash that a signature depends on. Everything else is a keystroke and lives in the trail.':
    'Zugehörigkeit ist eine Abfrage, keine Meinung: eine Zeile steht hier, wenn sie eine geschriebene Begründung trägt, wenn sie eine Zeile zerstört hat, deren einzige erhaltene Kopie der Eintrag selbst ist, oder wenn sie einen Hash erzeugt hat, von dem eine Unterschrift abhängt. Alles andere ist ein Tastendruck und lebt im Prüfpfad.',

  // ── zone 3 · the trail ──
  '{n} client-realm events': '{n} Ereignisse im Kunden-Bereich',
  'carry an IP': 'tragen eine IP',
  '{n} operator-realm events · {verbs} verbs': '{n} Ereignisse im Operator-Bereich · {verbs} Verben',
  'What happened': 'Was geschehen ist',
  '{verbs} verbs · {nouns} nouns': '{verbs} Verben · {nouns} Nomen',
  'The vocabulary did not load.': 'Das Vokabular wurde nicht geladen.',
  'Try again': 'Erneut versuchen',
  'Nothing has been recorded in this realm yet.': 'In diesem Bereich wurde noch nichts aufgezeichnet.',
  '{fam} — click to open, double-click to filter the trail to all {n} of them':
    '{fam} — Klick zum Öffnen, Doppelklick filtert den Prüfpfad auf alle {n}',
  '{action} · last {date}': '{action} · zuletzt {date}',
  'Operator': 'Operator',
  'Client': 'Kunde',
  'actor, IP and user-agent on every row': 'Akteur, IP und User-Agent auf jeder Zeile',
  'the manual logger takes no IP, so the column is empty by construction':
    'der manuelle Logger nimmt keine IP entgegen, die Spalte ist also konstruktionsbedingt leer',
  '{n} event on {date}': '{n} Ereignis am {date}',
  '{n} events on {date}': '{n} Ereignisse am {date}',
  'Newest first': 'Neueste zuerst',
  '{n} entries': '{n} Einträge',
  'of': 'von',
  'clear‖input': 'leeren',
  'Clear all': 'Alle entfernen',
  'Search the details…': 'Details durchsuchen…',
  'Search the trail': 'Prüfpfad durchsuchen',
  'Reading the record…': 'Die Aufzeichnung wird gelesen…',
  'Nothing matches': 'Nichts passt',
  'This combination exists in the vocabulary but not in the record. The catalogue on the left carries a count for every verb, so the nearest thing with rows is the one with the largest number.':
    'Diese Kombination gibt es im Vokabular, aber nicht in der Aufzeichnung. Der Katalog links trägt zu jedem Verb eine Zahl; das Nächstliegende mit Zeilen ist also das mit der grössten Zahl.',
  'Clear the filters': 'Filter zurücksetzen',
  'Nothing has been recorded in this realm': 'In diesem Bereich wurde nichts aufgezeichnet',
  'Every mutation in Signet writes one row here. An empty trail means nothing has been written yet — not that the recorder is off.':
    'Jede Änderung in Signet schreibt hier eine Zeile. Ein leerer Prüfpfad heisst, dass noch nichts geschrieben wurde — nicht, dass der Rekorder aus ist.',
  'client realm': 'Kunden-Bereich',
  'system · agent': 'System · Agent',
  'reason': 'Begründung',
  'only copy': 'einzige Kopie',
  'hash': 'Hash',
  'The reason, as written': 'Die Begründung, wie geschrieben',
  'Note — a constant the server writes ({n} row carries this exact string)':
    'Notiz — eine Konstante, die der Server schreibt ({n} Zeile trägt genau diesen Text)',
  'Note — a constant the server writes ({n} rows carry this exact string)':
    'Notiz — eine Konstante, die der Server schreibt ({n} Zeilen tragen genau diesen Text)',
  'field': 'Feld',
  'before': 'vorher',
  'after': 'nachher',
  'This entry records the act and nothing else — no before/after was captured.':
    'Dieser Eintrag hält den Vorgang fest und sonst nichts — kein Vorher/Nachher wurde erfasst.',
  'Copy the citation': 'Zitat kopieren',
  'Open {what} →': '{what} öffnen →',
  'This entry carries no route.': 'Dieser Eintrag trägt keine Route.',
  '← Newer': '← Neuere',
  'Older →': 'Ältere →',

  // ── zone 4 · switches ──
  '{wired} of {total} are read by anything': '{wired} von {total} werden von irgendetwas gelesen',
  'Revert': 'Verwerfen',
  'Saving…': 'Wird gespeichert…',
  'Save': 'Speichern',
  'nothing edited': 'nichts geändert',
  'The switches did not load': 'Die Schalter wurden nicht geladen',
  'Reading…': 'Wird geladen…',
  'This build exposes no settings': 'Dieser Build stellt keine Einstellungen bereit',
  'The whitelist in routes/admin.ts is empty.': 'Die Whitelist in routes/admin.ts ist leer.',
  'fixed‖model': 'Festpreis',
  'tm‖model': 'Nach Aufwand',
  'capped_tm‖model': 'Nach Aufwand mit Kostendach',
  'retainer‖model': 'Retainer',
  'Nothing reads this.': 'Nichts liest das.',
  'Read by': 'Gelesen von',
  'no consumer': 'kein Leser',
  "How the accent holds ATTEST's contrast law": 'Wie der Akzent das Kontrastgesetz von ATTEST einhält',
  'the first control was removed; this one is gated': 'das erste Bedienelement wurde entfernt; dieses ist abgesichert',
  'The first': 'Das erste',
  'derived its ramp on': 'leitete seine Rampe beim',
  'mount': 'Mount',
  'and wrote it inline on': 'ab und schrieb sie inline auf',
  '— so the tint applied only after someone opened Admin, drifted per session, never carried':
    '— der Farbton griff also erst, nachdem jemand Admin geöffnet hatte, driftete pro Sitzung, führte nie',
  ', and three of its five swatches failed AA with nothing on the write path but':
    ', und drei seiner fünf Farbfelder scheiterten an AA, ohne dass auf dem Schreibpfad mehr stand als',
  'Now: one exact colour.': 'Jetzt: eine exakte Farbe.',
  'derives the whole ramp —': 'leitet die ganze Rampe ab —',
  ', for day and for night (the same hue lifted to ≥ 8:1 on the night field) — and measures the six ratios you see above. The server runs the same code on the write path and refuses anything under {aa}:1 on the field, the sheet or a filled control. What passes is served as':
    ', für Tag und für Nacht (derselbe Farbton, auf dem Nachtfeld auf ≥ 8:1 angehoben) — und misst die sechs Kontraste, die Sie oben sehen. Der Server führt auf dem Schreibpfad denselben Code aus und lehnt alles unter {aa}:1 auf dem Feld, dem Blatt oder einem gefüllten Bedienelement ab. Was besteht, wird ausgeliefert als',
  ', linked after': ', eingebunden nach',
  'in both shells and read at boot before first paint: no inline styles, one tint everywhere, from the login page on.':
    'in beiden Shells und beim Start vor dem ersten Rendern gelesen: keine Inline-Styles, ein Farbton überall, von der Login-Seite an.',

  // ── modals ──
  'An admitted address may create ONE operator account at its first login. Nothing else changes: the address gets no admin rights, and withdrawing it later does not delete the account it created.':
    'Eine zugelassene Adresse darf beim ersten Login EIN Operator-Konto anlegen. Sonst ändert sich nichts: die Adresse erhält keine Admin-Rechte, und ein späteres Zurückziehen löscht das angelegte Konto nicht.',
  'Cancel': 'Abbrechen',
  'Admit it': 'Zulassen',
  'Current password': 'Aktuelles Passwort',
  'New password': 'Neues Passwort',
  'At least 8 characters.': 'Mindestens 8 Zeichen.',
  'New password again': 'Neues Passwort wiederholen',
  'Change it': 'Ändern',
  'Revoke every live agent key': 'Jeden aktiven Agent-Schlüssel widerrufen',
  'Revoke them': 'Widerrufen',
  'Every unrevoked': 'Jede noch gültige Zeile in',
  'row is marked revoked. A run in flight loses the tool surface at its next call and will fail; nothing already written is undone. New keys are minted per run, so the next dispatch works normally.':
    'wird als widerrufen markiert. Ein laufender Lauf verliert die Tool-Oberfläche beim nächsten Aufruf und schlägt fehl; nichts bereits Geschriebenes wird rückgängig gemacht. Neue Schlüssel werden pro Lauf erzeugt, der nächste Dispatch funktioniert also normal.',
  'Close registration': 'Registrierung schliessen',
  'becomes': 'wird zu',
  '. Accounts that already exist keep working; only the creation of NEW accounts is restricted to admitted addresses.':
    '. Bestehende Konten funktionieren weiter; nur das Anlegen NEUER Konten ist auf zugelassene Adressen beschränkt.',
  'Withdraw an admitted email': 'Zugelassene E-Mail zurückziehen',
  'Withdraw it': 'Zurückziehen',
  'can no longer create an operator account. If it already created one, that account keeps working — this is the door, not the room.':
    'kann kein Operator-Konto mehr anlegen. Falls sie bereits eines angelegt hat, funktioniert dieses Konto weiter — das hier ist die Tür, nicht der Raum.',
}, 'AdminPage');
